import { Injectable } from '@angular/core';
// Angular common
import { HttpClient, HttpHeaders } from '../common/angular.index';
// Models
import {
  AppConstants,
  DocumentStatesResponse,
  DocumentState,
  BaseResponse,
} from '../common/models.index';
import { SessionService } from './session.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class DocumentStateService {
  constructor(
    private http: HttpClient,
    private sessionService: SessionService
  ) {}

  getDocumentStates() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${this.sessionService.session.Token}`,
    });
    return this.http.get<DocumentStatesResponse>(
      `${environment.ApiUrl}api/DocumentState/GetDocumentStates`,
      { headers }
    );
  }

  handlePostOrPutState(docState: DocumentState) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${this.sessionService.session.Token}`,
    });

    if (docState.Id > 0)
      return this.http.put<BaseResponse>(
        `${environment.ApiUrl}api/DocumentState/PutDocumentState`,
        docState,
        { headers }
      );
    else
      return this.http.post<BaseResponse>(
        `${environment.ApiUrl}api/DocumentState/PostDocumentState`,
        docState,
        { headers }
      );
  }

  deleteState(id: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${this.sessionService.session.Token}`,
    });
    return this.http.delete<BaseResponse>(
      `${environment.ApiUrl}api/DocumentState/DeleteDocumentState?id=${id}`,
      { headers }
    );
  }
}
